import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React from "react";
import { css } from "styled-components";

export interface ResourceDetailPagestyle {
    ResourceContainer?: GridContainerProps;
    ResourceListContainer?: GridItemProps;
    ResourceListItemContainer?: GridItemProps;
    ResourceimgContainer?: GridItemProps;
}

export const ResourcePagestyle: ResourceDetailPagestyle = {
    ResourceContainer: {
        gap: 0,
        css: css`
            wdith: 100%;
            max-width: 1140px;
            margin: 0 auto;
        `,
    },
    ResourceimgContainer: {
        width: 12,
        css: css``,
    },
    ResourceListContainer: {
        width: [12, 12, 12, 3, 3],
        css: css`
            padding: 0;
        `,
    },
    ResourceListItemContainer: {
        width: [12, 12, 12, 9, 9],
        css: css`
            margin-top: -63px !important;
            background-color: #fff;
            padding: 0;
            margin-bottom: 29px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};
const INTResourceDetailsPage = (props: PageProps) => {
    return (
        <Page
            css={css`
                max-width: 100% !important;
                padding: 0 !important;
            `}
        >
            <GridItem {...ResourcePagestyle.ResourceimgContainer}>
                <Zone contentId={props.id} zoneName="Content" />
            </GridItem>
            <GridContainer {...ResourcePagestyle.ResourceContainer}>
                <GridItem {...ResourcePagestyle.ResourceListContainer}>
                    <Zone contentId={props.id} zoneName="Content2" />
                </GridItem>
                <GridItem {...ResourcePagestyle.ResourceListItemContainer}>
                    <Zone contentId={props.id} zoneName="Content3" />
                </GridItem>
            </GridContainer>
        </Page>
    );
};

const pageModule: PageModule = {
    component: INTResourceDetailsPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "Content",
    },
};

export default pageModule;
